// removed by extract-text-webpack-plugin
module.exports = {"textToggle":"textToggle__2tDYE","textToggleCanToggle":"textToggleCanToggle__370y1","textToggleText":"textToggleText__1D8Gq","textExpandButton":"textExpandButton__ewQGF","textShrinkButton":"textShrinkButton__1tLJU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextToggle/index.css
// module id = 1474
// module chunks = 0